// Castintech dashboard — constants/config (TypeScript).
// Faz 9b PR3 — dashboard.html'den extract.
// Faz 12 PR-C — config.js → config.ts (gem/role/model literal types).

export const API = '/castintech-api/proxy/api' as const;
export const H: Readonly<Record<string, string>> = { 'Content-Type': 'application/json' };
export const REFRESH_INTERVAL = 20000;
export const META_TTL_MS = 60_000;
export const SAGLIK_REFRESH_MS = 30_000;
export const AUDIT_TRIM_BASE = 100;
export const SSE_FALLBACK_THRESHOLD = 5;
export const SSE_FALLBACK_INTERVAL_MS = 60_000;

// Gem config — agent display attributes.
export interface GemConfig {
  name: string;
  icon: string;
  cls: string;
  bg: string;
  role?: string;
}

// Gem mapping — agent name → display config (icon, gradient, css class).
export const GEMS: Readonly<Record<string, GemConfig>> = {
  'Orkestrat':  { name:'Atlas',    icon:'⚡', cls:'gem-atlas',    bg:'#4c1d95,#7c3aed' },
  'Reklam':     { name:'Topaz',    icon:'🎯', cls:'gem-topaz',    bg:'#78350f,#d97706' },
  'Kreatif':    { name:'Opal',     icon:'✨', cls:'gem-opal',     bg:'#831843,#db2777' },
  'PM':         { name:'Jade',     icon:'🛡️', cls:'gem-jade',     bg:'#064e3b,#059669' },
  'Lead':       { name:'Garnet',   icon:'🔥', cls:'gem-garnet',   bg:'#4c0519,#9f1239' },
  'Sales':      { name:'Ruby',     icon:'💎', cls:'gem-ruby',     bg:'#7f1d1d,#dc2626' },
  'Onboard':    { name:'Pearl',    icon:'⭐', cls:'gem-pearl',    bg:'#1e293b,#475569' },
  'Fiyat':      { name:'Sapphire', icon:'⚖️', cls:'gem-sapphire', bg:'#1e3a8a,#1d4ed8' },
  'Fatura':     { name:'Crystal',  icon:'📋', cls:'gem-crystal',  bg:'#164e63,#0891b2' },
  'deme':       { name:'Zircon',   icon:'💳', cls:'gem-zircon',   bg:'#134e4a,#0d9488' },
  'Forge':      { name:'Forge',    icon:'🔧', cls:'gem-garnet',   bg:'#4c0519,#9f1239' },
  'Pilot':      { name:'Pilot',    icon:'🚀', cls:'gem-sapphire', bg:'#1e3a8a,#1d4ed8' },
  'Lore':       { name:'Lore',     icon:'📚', cls:'gem-crystal',  bg:'#164e63,#0891b2' },
  'Nexus':      { name:'Nexus',    icon:'🌐', cls:'gem-atlas',    bg:'#1a1a2e,#16213e' },
  'Prism':      { name:'Prism',    icon:'🎨', cls:'gem-opal',     bg:'#2d1b69,#6d28d9' },
  'Herald':     { name:'Herald',   icon:'📡', cls:'gem-topaz',    bg:'#451a03,#b45309' },
  'efqm-gm':    { name:'efqm-gm',  icon:'📊', cls:'gem-efqm-gm',  bg:'#0f5132,#198754' },
};

export const ROLE_LABELS: Readonly<Record<string, string>> = {
  ceo:'CEO', cto:'CTO', cmo:'CMO', cfo:'CFO',
  engineer:'Mühendis', designer:'Tasarımcı', pm:'PM',
  qa:'QA', devops:'DevOps', researcher:'Araştırmacı', general:'Genel Müdür'
};

export interface ModelLabel {
  short: string;
  color: string;
}

export const MODEL_LABELS: Readonly<Record<string, ModelLabel>> = {
  'claude-opus-4-7':            { short: 'Opus 4.7',   color: '#a78bfa' },
  'claude-sonnet-4-6':          { short: 'Sonnet 4.6', color: '#60a5fa' },
  'claude-haiku-4-5-20251001':  { short: 'Haiku 4.5',  color: '#4ade80' },
};
